/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 * **/
export const SET_SELECTED_INPUT = 'SET_SELECTED_INPUT';
export const IS_LOADING = 'IS_LOADING';
export const SET_REQUEST_SCREEN_GRID = 'SET_REQUEST_SCREEN_GRID';
export const REFRESH_QUAERTERLY_CLAIMS_RECONCILLIATION =
  'REFRESH_QUAERTERLY_CLAIMS_RECONCILLIATION';
export const SET_HEADER_GRID = 'SET_HEADER_GRID';
export const SET_RIGHT_GRID_DATA = 'SET_RIGHT_GRID_DATA';
export const SET_LEFT_GRID_DATA = 'SET_LEFT_GRID_DATA';
export const SET_SELECTED_REQUEST = 'SET_SELECTED_REQUEST';
export const SET_LAST_UPDATED_USERID_AND_COUNT =
  'SET_LAST_UPDATED_USERID_AND_COUNT';
export const SET_SCHEDULE_MESSAGE = 'SET_SCHEDULE_MESSAGE';
export const SET_LEFT_GRID_DATA_FOR_ALL = 'SET_LEFT_GRID_DATA_FOR_ALL';
export const SET_RIGHT_GRID_DATA_FOR_ALL = 'SET_RIGHT_GRID_DATA_FOR_ALL';
// actionTypes.js
export const CLEAR_EXPORT_DATA = 'CLEAR_EXPORT_DATA';